var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNameQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4408 11.1646H7.01228C3.54085 11.1646 0.726562 13.9349 0.726562 17.3521C0.726562 17.9733 1.23835 18.4771 1.86942 18.4771H15.5837C16.2148 18.4771 16.7266 17.9733 16.7266 17.3521C16.7266 13.9349 13.9123 11.1646 10.4408 11.1646ZM2.47621 16.7896C2.75835 14.5712 4.68371 12.8521 7.01228 12.8521H10.4408C12.768 12.8521 14.6944 14.5729 14.9766 16.7896H2.47621ZM8.72656 9.47705C11.2512 9.47705 13.298 7.46225 13.298 4.97705C13.298 2.49186 11.2512 0.477051 8.72656 0.477051C6.20192 0.477051 4.15513 2.49186 4.15513 4.97705C4.15513 7.4626 6.20156 9.47705 8.72656 9.47705ZM8.72656 2.16455C10.3019 2.16455 11.5837 3.42631 11.5837 4.97705C11.5837 6.52779 10.3019 7.78955 8.72656 7.78955C7.15121 7.78955 5.86942 6.52744 5.86942 4.97705C5.86942 3.42631 7.15156 2.16455 8.72656 2.16455Z",
    fill: "#0E7490"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameQuestion);
export default __webpack_public_path__ + "static/media/name-question.65086d0bac526a4c510b0796d7b5a1db.svg";
export { ForwardRef as ReactComponent };